import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Home from './pages/Home';
import Authentication from './pages/Authentication';
import Endpoints from './pages/Endpoints';
import Examples from './pages/Examples';
import RateLimiting from './pages/RateLimiting';
import ErrorCodes from './pages/ErrorCodes';
import Support from './pages/Support';
import Workspaces from './pages/Workspaces';
import ApiKeys from './pages/ApiKeys';
import SendTemplate from './pages/SendTemplate';
import Contacts from './pages/Contacts';
import Groups from './pages/Groups';
import Templates from './pages/Templates';
import Campaigns from './pages/Campaigns';
import Webhooks from './pages/Webhooks';
import Scopes from './pages/Scopes';
import Integrations from './pages/Integrations';
import './App.css';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <Router>
      <div className="app">
        <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <div className="main-container">
          <Sidebar isOpen={sidebarOpen} />
          <main className={`content ${sidebarOpen ? 'with-sidebar' : ''}`}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/authentication" element={<Authentication />} />
              <Route path="/endpoints" element={<Endpoints />} />
              <Route path="/examples" element={<Examples />} />
              <Route path="/rate-limiting" element={<RateLimiting />} />
              <Route path="/error-codes" element={<ErrorCodes />} />
              <Route path="/support" element={<Support />} />
              <Route path="/workspaces" element={<Workspaces />} />
              <Route path="/api-keys" element={<ApiKeys />} />
              <Route path="/send-template" element={<SendTemplate />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/groups" element={<Groups />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/webhooks" element={<Webhooks />} />
              <Route path="/scopes" element={<Scopes />} />
              <Route path="/integrations" element={<Integrations />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;
